import { render } from "./ControlBar.vue?vue&type=template&id=5e477440&scoped=true"
import script from "./ControlBar.vue?vue&type=script&lang=js"
export * from "./ControlBar.vue?vue&type=script&lang=js"

import "./ControlBar.vue?vue&type=style&index=0&id=5e477440&scoped=true&lang=css"

import exportComponent from "/tmp/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e477440"]])

export default __exports__